import {
  composeMessageSchema, composePreviewSchema, sendCommunicationRequestSchema, sendCommunicationResponseSchema,
  type ComposeMessage, type ComposePreview, type SendCommunicationRequest, type SendCommunicationResponse,
} from '@vigeo/shared';
import { fixtureMode } from '../../lib/data-mode.js';

const READ_ONLY = 'Sending email requires the local test API; design fixtures are read-only.';

async function post(path: string, body: unknown): Promise<unknown> {
  const response = await fetch(path, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) });
  const parsed: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const error = typeof parsed === 'object' && parsed !== null && 'error' in parsed && typeof parsed.error === 'string' ? parsed.error : 'The message could not be processed.';
    throw new Error(error);
  }
  return parsed;
}

/** The message as the server renders it for this person — or the merge fields it cannot fill. */
export async function previewCommunication(personId: string, message: ComposeMessage): Promise<ComposePreview> {
  if (fixtureMode) throw new Error(READ_ONLY);
  return composePreviewSchema.parse(await post(`/api/people/${encodeURIComponent(personId)}/communications/preview`, composeMessageSchema.parse(message)));
}

/** Record the message queued; the mail service sends it. */
export async function sendCommunication(personId: string, request: SendCommunicationRequest): Promise<SendCommunicationResponse> {
  if (fixtureMode) throw new Error(READ_ONLY);
  return sendCommunicationResponseSchema.parse(await post(`/api/people/${encodeURIComponent(personId)}/communications`, sendCommunicationRequestSchema.parse(request)));
}
